module.exports = __webpack_public_path__ + "img/model1.81ef97c3.gif";